import React from 'react';
import { Props, State } from './interfaces';

class ErrorBoundary extends React.Component<Props, State> {
  state = { hasError: false };

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ hasError: true });
    // Log the error to an error reporting service
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1 style={{ color: 'black' }}>ERROR</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
